define([], function () {
	var getAsset = function(filepath) {
		return window.cj.assets[filepath];
	};

	return {
		getAsset: getAsset
	};
});
